const DpoEsp = {
    init: function () {
        const tlacitko = $("#tlacitko-esp");

        if (!tlacitko.length) {
            return;
        }

        tlacitko
            .off("click")
            .on("click", function (e) {
                e.preventDefault();
                if ($(this).hasClass("disabled")) {
                    return;
                }
                DpoEsp.vyhledejSubjekt();
            });
    },

    vyhledejSubjekt: function () {
        let url = window.location.protocol + "//" + window.location.host;
        url += "/ajax/esp/vyhledejSubjekt";

        const section = $('#idSection');
        if (section.length && section.val()) {
            url += '/' + section.val();
        }
        const item = $('#idItem');
        if (item.length && item.val()) {
            url += '/' + item.val();
        }

        let postData = {};

        const _ch = $("#_ch");
        if (_ch.length) {
            postData["_ch"] = _ch.val();
        }

        const forma = $("#subjekttyp");
        if (forma.length) {
            postData["formaId"] = forma.val();
            if (1 === parseInt(forma.val())) {
                const datumNarozeni = $("#subjektdatumnarozeni");
                postData["datumNarozeni"] = null;
                if (datumNarozeni.length) {
                    postData["datumNarozeni"] = datumNarozeni.val();
                }

                const jmeno = $("#subjektjmeno");
                postData["jmeno"] = null;
                if (jmeno.length) {
                    postData["jmeno"] = jmeno.val();
                }

                const prijmeni = $("#subjektprijmeni");
                postData["prijmeni"] = null;
                if (prijmeni.length) {
                    postData["prijmeni"] = prijmeni.val();
                }
            } else {
                const ico = $("#subjektico");
                postData["ico"] = null;
                if (ico.length) {
                    postData["ico"] = ico.val();
                }
            }
        } else {
            Lemo_Alert.addDanger("Není zadána forma subjektu.", "vyhledaniSubjektuError");
            return;
        }

        $.ajax({
            type: "post",
            url: url,
            data: postData,
            dataType: "json",
            global: true,
            beforeSend: function () {
                Lemo_Alert.closeAll();
                Lemo_Alert.addInfo("Vyhledávám subjekt ...", "vyhledaniSubjektuBeforeSend");
            },
            complete: function () {
                Lemo_Alert.closeById("vyhledaniSubjektuBeforeSend");
            },
            success: function (r) {
                if (r.hasOwnProperty("messages")) {
                    Lemo_Alert.addMany(r.messages);
                }

                if (r.hasOwnProperty("status") && true === r.status) {
                    if (r.hasOwnProperty("data")) {
                        const data = r["data"];
                        if (data.hasOwnProperty("espId")) {
                            const espId = $("#idesp");
                            if (espId.length) {
                                espId.val(data["espId"]);
                            }
                        }
                    }
                }
            },
            error: function () {
                Lemo_Alert.addDanger("Vyhledání subjektu selhalo.", "vyhledaniSubjektuError");
            }
        });
    },
}

$(document).ready(function () {
    DpoEsp.init();
});